module.exports = __webpack_public_path__ + "static/after2-afdeb60d88160dff8ebbfc3d9aa6d6b0.jpg";